import React, { Component } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import Countdown from 'react-countdown-now';
import Logout from '../Logout/Logout';
import IdleTimer from 'react-idle-timer';
import AxiosInstance from '../AxiosInstance/AxiosInstance';



class Idle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modal: props.ModalState,
        };

        this.state = {
            timeout: 900000,
            showModal: false,
        }


        this.idleTimer = null
        this.onIdle = this._onIdle.bind(this)
        this.continueWork = this.continueWork.bind(this)
        this.logout = this.logout.bind(this)
    }


    _onIdle(e) {
        if (sessionStorage.getItem("NewQRadar_accessToken") !== null) {
            this.setState({
                showModal: true
            });
        } else {

            this.idleTimer.reset();
        }
    }



    continueWork() {
        AxiosInstance({
            method: "post",
            url: "Token/RefreshToken",
            data: {
                accessToken: sessionStorage.getItem("NewQRadar_accessToken"),
                refreshToken: sessionStorage.getItem("NewQRadar_refreshToken")
            }
        }).then(response => {

            if (response.data !== "error") {
                sessionStorage.setItem('NewQRadar_accessToken', response.data.accessToken);
                sessionStorage.setItem('NewQRadar_refreshToken', response.data.refreshToken);

                this.updateRefreshToken();

            }
            else {
                Logout.helper();
              //  window.location.hash = "/errorpage?errorcode=" + "500" + "&errormessage=" + "Server Error";
            }

            this.setState({ showModal: false });
        });


    }

    updateRefreshToken() {

        AxiosInstance({
            method: "post",
            url: "tbSYS_m_Token/usp_tbSYS_m_Token_Update_v12",
            data: {
                accessToken: sessionStorage.getItem("NewQRadar_accessToken"),
                refreshToken: sessionStorage.getItem("NewQRadar_refreshToken")
            }
        }).then(response => {
            if (response.data == false) {
                Logout.helper();
                // window.location.hash = "/errorpage?errorcode=" + "500" + "&errormessage=" + "Server Error";
            } else {
                this.idleTimer.reset();
            }
        });
    }

    logout() {
        Logout.helper();
        this.setState({ showModal: false });
    }

    render() {
        const renderer = ({ minutes, seconds, completed }) => {
            if (completed) {
                this.logout();
            } else {
                return <span> {minutes}:{seconds} </span>;
            }
        };

        return (

            <div>
                <IdleTimer
                    ref={ref => { this.idleTimer = ref }}
                    element={document}
                    onActive={this.onActive}
                    onIdle={this.onIdle}
                    onAction={this.onAction}
                    timeout={this.state.timeout} />

                <div>
                    <Modal isOpen={this.state.showModal} className={'modal-warning ' + this.props.className} backdrop='static'>
                        <ModalHeader >Session Timeout</ModalHeader>
                        <ModalBody>
                            Your session will be expired in
                        <Countdown
                                date={Date.now() + 300000}
                                renderer={renderer}
                            />
                            Do you want to continue?
                   </ModalBody>
                        <ModalFooter>
                            <Button color="primary" onClick={this.continueWork}>Continue</Button>{' '}
                            <Button color="secondary" onClick={this.logout}>Logout</Button>
                        </ModalFooter>
                    </Modal>

                </div>
            </div>

        );
    }


}

export default Idle;
